/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Generalfundmaterials_Tooltip2Inputs */

const en_settings_generalfundmaterials_tooltip2 = /** @type {(inputs: Settings_Generalfundmaterials_Tooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General fund materials access is required to modify this setting`)
};

/**
* | output |
* | --- |
* | "General fund materials access is required to modify this setting" |
*
* @param {Settings_Generalfundmaterials_Tooltip2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_generalfundmaterials_tooltip2 = /** @type {((inputs?: Settings_Generalfundmaterials_Tooltip2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Generalfundmaterials_Tooltip2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_generalfundmaterials_tooltip2(inputs)
});
export { settings_generalfundmaterials_tooltip2 as "settings_generalFundMaterials_tooltip" }